import {AxiosResponse} from "axios";
import {RolePermissions} from "../../../../declerations/server/role_models";
import {axiosSpringInstance} from "../../../BackofficeApiManager";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";

export interface CurrentUserResponse {
  permissions: RolePermissions;
}

export const getSpringUser = async (): Promise<CurrentUserResponse> => {
  const response = await axiosSpringInstance.get<CurrentUserResponse, AxiosResponse<CurrentUserResponse>>("/auth/me");
  return response.data;
};

export const useGetSpringUser = (
  options?: BaseQueryOptions<CurrentUserResponse, void>
): BaseUseQueryResult<CurrentUserResponse> => {
  return useBaseQuery<CurrentUserResponse, void>(["current-user"], getSpringUser, undefined, options);
};
